import { Moment } from 'moment';
import { DeliveryIntegrationInstallType } from './delivery-integration-install-type';
import { DeliveryIntegrationStatus } from './delivery-integration-status';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { DeliveryIntegrationSchema } from './delivery-integration.schema';
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';

@DtoForceConstructor
export class DeliveryIntegration implements Entity {
    public id: string;
    public provider: string;
    public providerName: string;
    public shortDescription: string;
    public description: string;
    public logoSmall: string;
    public keywords: string[];
    public installType: DeliveryIntegrationInstallType;
    public status: DeliveryIntegrationStatus;
    public customerId: string;
    public createdAt: Moment;

    @DtoImport(DeliveryIntegrationSchema)
    static import(dto: Dto): any {}

    constructor(value?: {
        id: string;
        provider: string;
        providerName: string;
        shortDescription: string;
        description: string;
        logoSmall: string;
        keywords: string[];
        installType: DeliveryIntegrationInstallType;
        status: DeliveryIntegrationStatus;
        customerId: string;
        createdAt: Moment;
    }) {
        if (!!value) {
            this.id = value.id;
            this.provider = value.provider;
            this.providerName = value.providerName;
            this.shortDescription = value.shortDescription;
            this.description = value.description;
            this.logoSmall = value.logoSmall;
            this.keywords = value.keywords;
            this.installType = value.installType;
            this.status = value.status;
            this.customerId = value.customerId;
            this.createdAt = value.createdAt;
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryIntegrationSchema,
        },
    ])
    export(type?: DtoType): any {}
}
